import useApiQuery from '../useApiQuery';
import keys from './keys';

const useGetUserInfo = ({ disabled = false } = {}) => {
  const query = useApiQuery({
    requestUrl: '/me/user-info',
    disabled,
    queryKey: keys.userInfo,
  });

  return {
    userInfo: query.data,
    userInfoError: query.error,
    isUserInfoFetchError: query.isError,
    isUserInfoFetchSuccess: query.isSuccess,
    isUserInfoFetching: query.isFetching,
    isUserInfoLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetUserInfo;
